import { useMatchMedia } from '@office-start/dom-utility';
import React, { useMemo } from 'react';
import { protectedBackgroundGradient } from './constants';
import { useProtectedGradientStyles } from './ProtectedGradientControl.styles';
export var ProtectedGradientControl = function (_a) {
    var backgroundGradient = _a.backgroundGradient, themeId = _a.themeId, widthRestrictorOffset = _a.widthRestrictorOffset;
    var styles = useProtectedGradientStyles();
    var isMax480 = useMatchMedia('(max-width: 480px)');
    var isMax1920 = useMatchMedia('(max-width: 1920px) and (min-width:480px');
    var isMin1920 = useMatchMedia('(min-width: 1920px)');
    var direction = document.dir === 'rtl' ? 'RTL' : 'LTR';
    var protectedGradientStyle = useMemo(function () {
        var _a;
        var gradientLeft = (_a = protectedBackgroundGradient[themeId]) === null || _a === void 0 ? void 0 : _a["".concat(backgroundGradient).concat(direction)];
        if (!gradientLeft) {
            return undefined;
        }
        return {
            backgroundImage: gradientLeft,
            width: isMax480
                ? '320px'
                : isMax1920
                    ? '480px'
                    : isMin1920
                        ? "calc(".concat(widthRestrictorOffset, " + 480px)")
                        : '480px',
        };
    }, [
        backgroundGradient,
        direction,
        isMax480,
        isMax1920,
        isMin1920,
        themeId,
        widthRestrictorOffset,
    ]);
    return (React.createElement(React.Fragment, null, protectedGradientStyle ? (React.createElement("div", { className: styles.protectedGradientDiv, style: protectedGradientStyle })) : null));
};
//# sourceMappingURL=ProtectedGradientControl.js.map